import BaseApiService from './api.base.service'

class UsersApiService extends BaseApiService {
  constructor() {
    super('users')
  }

  getCorsiAbbonamentoELearningByIdUtente(id) {
    return this.callGet(`/${id}/courses/abbonamentoelearning`)
  }

  getCorsiEcpassByIdUtente(id) {
    return this.callGet(`/${id}/courses/ecpass`)
  }

  getProdottiEcpassByIdUtente(id) {
    return this.callGet(`/${id}/products/ecpass`)
  }

  isFiscalCodePresent(fiscalCode) {
    return this.callPost('/fiscal-codes/is-present', fiscalCode)
  }

  checkUserCredentials() {
    return this.callGet('/credentials/check')
  }

  updateUserCredentials(credentials) {
    return this.callPost('/credentials/update', credentials)
  }

  isAssociatedTsId() {
    return this.callGet('/tsid/is-associated')
  }

  associateTsId(tsId) {
    return this.callPost('/tsid/associate', tsId)
  }

  associateFiscalCode(fiscalCode) {
    return this.callPost('/fiscal-codes/associate', fiscalCode)
  }

  validateFiscalCode(fiscalCode) {
    return this.callPost('/fiscal-codes/validate', fiscalCode)
  }

  getAllowedNumberOfAttempts(user) {
    return this.callPost('/attempts', user)
  }

  getUserGroups() {
    return this.callGet('/groups')
  }

  addUserToClientGroup() {
    return this.callPost('/groups/client/associate')
  }

  addUserToParticipantGroup() {
    return this.callPost('/groups/participant/associate')
  }

  doesUserBelongToParticipantGroup() {
    return this.callGet('/groups/participant/belongs')
  }

  multipleTsIdAssociations(tsId) {
    return this.callPost('/tsid/multiple', tsId)
  }

  vatNumberOnly() {
    return this.callGet('/vat-numbers/only')
  }

  isAssociatedSameTsId(tsId) {
    return this.callPost('/tsid/same', tsId)
  }

  isTsIdPresent(tsId) {
    return this.callPost('/tsid/is-present', tsId)
  }

  getMarketingOfferInfo(marketingOfferId) {
    return this.callPost('/marketing/info', marketingOfferId)
  }

  associateTsIdForMarketingOffer(tsId, marketingOfferId, userId) {
    return this.callPost('/marketing/tsid/associate', {
      tsid: tsId,
      marketingOfferId: marketingOfferId,
      userId: userId,
    })
  }

  getUserById(userId) {
    return this.callGet('/' + userId)
  }

  getUserPersonalData() {
    return this.callGet('/personal-data')
  }

  IsUserClientPartecipant(userId) {
    return this.callGet('/' + userId + '/is-user-client-partecipant')
  }

  getUserFiscalCode(userId) {
    return this.callGet('/' + userId + '/fiscal-code')
  }

  doesClientExistWithVatNumber(journalActivationId) {
    return this.callPost(`/clients/vat-numbers/exists`, journalActivationId)
  }

  areFiscalCodeOrVatNumberPresent(fiscalCode, vatNumber) {
    return this.callPost('/usernames/present', {
      fiscalCode,
      vatNumber,
    })
  }

  checkTmkUsersExistence(users) {
    return this.callPost('/tmk-users/exists', users)
  }
  insertTmkUsers(users) {
    return this.callPost('/tmk-users', users)
  }
}

export const usersApi = new UsersApiService()
